import React, { useEffect, useState } from 'react'
import './movies.css'
import getMovie from '../../Services/Queries/GetMovie'
import AwsConfig from '../../Config/AwsConfig'
import {
  initialmovieInputValue,
  intitalBooleanValueChangeDone,
} from '../Data/StaticPersonandMoviedata'
import { movieDataInput, ottLink, removeTrailingZeros } from './movieInput'
import GetFormattedDate from './getFormateddateforlistmovies'
import { Auth } from 'aws-amplify'
import GetUserPermissions from '../../Services/Queries/GetUserPermissions'
import { DefinedPermissions } from '../Constants/Permissions'
import { useHistory } from 'react-router-dom'
import Uicomponentmovie from './Uicomponentmovie'
import SubmitEditMovie from './Submiteditmovie'
import {
  ArticleValidation,
  checkArticleRating,
  // ReviewValidation,
  checkOTTStatus,
  checkOttAndUrl,
  checkOttFieldsDateExistsorNot,
  checkReviewValidationEn,
  checkReviewValidationTe,
  // checkReviewValidationEn,
  // checkReviewValidationTe,
  checkValidation,
  releaseDateValidation,
} from './MovieValidationFunctions'

const EditMovie = props => {
  // Props for this file
  const { modeUrl, editData, active, handleActiveChange } = props

  // State variables
  const [movieData, setMovieData] = useState()
  const [pkvalue, setPkValue] = useState('')
  const [BooleanValueforDisplayingUi, setBooleanValueforDisplayingUi] = useState(false)
  const [inputData, setInputData] = useState(initialmovieInputValue)
  const [BooleanValueChangeDone, setBooleanValueChangeDone] = useState(
    intitalBooleanValueChangeDone,
  )
  const [moviePersons, setMoviePersons] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [loadPopup, setLoadPopup] = useState(false)
  const [EDitApproveOptionBoolean, setEDitApproveOptionBoolean] = useState(false)
  const [editOttAndNewsPermission, setEditOttNewsPermission] = useState(false)
  const [DeleteOttAndNewsPermission, setDeleteOttNewsPermission] = useState(false)
  const [ApproveOttAndNewsPermission, setApproveOttNewsPermission] = useState(false)
  const [horizonataImage, setHorizontalImage] = useState(false)

  // Episodes and Rating calculation
  const episodesandRating =
    (inputData.contentType === 'movies' ? true : inputData.noOfEpisodes !== '') &&
    (inputData.imdb !== '' || inputData.MovieYouSayRating !== '')

  const history = useHistory()

  // Function to record whether a value is edited or changed
  const sendBooleanValueChangeDone = (field, data) => {
    const BooleanValueforValueChangeTemp = { ...BooleanValueChangeDone }
    BooleanValueforValueChangeTemp[field] = data
    setBooleanValueChangeDone(BooleanValueforValueChangeTemp)
  }

  // Function to update input data object for a single field
  const updateInputData = (fieldName, fieldValue) => {
    const data = { ...inputData }
    data[fieldName] = fieldValue
    setInputData(data)
  }

  // Function to update multiple input data to input object at once
  const updateMultipleInputData = input => {
    const data = { ...inputData }
    Object.keys(input).forEach(keyName => {
      data[keyName] = input[keyName]
    })
    setInputData(data)
  }

  // Function to fetch movie data
  const getMovieData = async pkValue => {
    setIsLoading(true)

    // Existing movie data
    const movieDataFromWiki = props.dataFromWiki
    setMovieData(props.moviedatawiki)

    // Movie persons data
    const moviePersonsTemp = props.moviePersons
    setMoviePersons(moviePersonsTemp)

    let movieData = initialmovieInputValue

    // If data is available from the Wiki, update the input data
    if (movieDataFromWiki) {
      setInputData(movieDataFromWiki)
    }

    // Fetch user permissions
    const permissionInput = {
      mobileNumber: Auth.user.attributes.phone_number,
    }
    const userPermissions = await GetUserPermissions(permissionInput)
    const permissions = []
    const permissionsArr = []

    // Extract permissions from userRolesAndPermissions
    if (userPermissions && userPermissions.userRolesAndPermissions) {
      userPermissions.userRolesAndPermissions.forEach(item => {
        permissions.push(...item.permissions)
      })

      permissions.forEach(permission => {
        permissionsArr.push(permission.name)
      })
    }

    // Check if the "DisplayApproveMovieOption" permission is present
    const EDitApproveOption = permissionsArr.includes(DefinedPermissions.DisplayApproveMovieOption)
    const editOttAndNews = permissionsArr.includes(DefinedPermissions.MovieAndOTTNewsEdit)
    const DeleteOttAndNews = permissionsArr.includes(DefinedPermissions.MovieAndOTTNewsDelete)
    const ApproveOttAndNews = permissionsArr.includes(DefinedPermissions.MovieAndOTTNewsApprove)
    setEDitApproveOptionBoolean(EDitApproveOption)
    setEditOttNewsPermission(editOttAndNews)
    setDeleteOttNewsPermission(DeleteOttAndNews)
    setApproveOttNewsPermission(ApproveOttAndNews)

    // If movie data is not from the Wiki, fetch it from the service
    if (!movieDataFromWiki) {
      const url = window.location.href
      const urlSplit = url.split('?')
      setPkValue(decodeURIComponent(urlSplit[1] ? urlSplit[1] : pkValue ? pkValue : ''))

      if (urlSplit[1]) {
        setBooleanValueforDisplayingUi(true)
      }

      const input = {
        movieID: decodeURIComponent(urlSplit[1] ? urlSplit[1] : pkValue),
      }

      try {
        movieData = await getMovie(input)

        const movieDataExists = movieData && movieData
        let posterUrl = movieDataExists && movieData.posterURL ? movieData.posterURL : ''

        // Add CDN URL to poster URL if not present
        const cdnUrl = AwsConfig.movieCdnUrl
        if (posterUrl && !posterUrl.includes(cdnUrl)) {
          posterUrl = cdnUrl + posterUrl
        }

        // Generate OTT links
        const oTTLinkRender = await ottLink(movieDataExists)

        const ottDateRender =
          movieDataExists && movieData.ottReleasedDate
            ? removeTrailingZeros(movieData.ottReleasedDate)
            : ''

        const ottArray = [
          oTTLinkRender.link.length >= 1 ? oTTLinkRender.link : [{ link: '' }],
          oTTLinkRender.ott.length >= 1
            ? oTTLinkRender.ott
            : [
                {
                  label: '',
                  value: '',
                  ottDate: GetFormattedDate(ottDateRender),
                },
              ],
        ]

        // Update movie data in the state
        const movieDataHere = movieDataInput(movieDataExists, posterUrl, ottArray)
        updateMultipleInputData(movieDataHere)
        setMovieData(movieData)
      } catch (error) {
        console.warn(error, 'error')
        setMovieData()
      }
    }

    setIsLoading(false)
  }

  // Function to handle content type change
  const handleContentTypeChange = (field, data) => {
    const dataTemp = { ...inputData }
    dataTemp[field] = data
    setInputData(dataTemp)
  }

  // // Function to check if OTT fields exist based on certain conditions
  // const checkOttFieldsDateExistsorNot = (checkOttFieldsExists, ottDates) => {
  //
  //   if (checkOttFieldsExists) {
  //     if (ottDates.length > 0) {
  //       return true
  //     }

  //     return false
  //     // const releaseDate = new Date(inputData.releaseDate).getFullYear()
  //     // return releaseDate <= 2015 || inputData.ottDateUi
  //   }

  //   return true
  // }

  // const checkValidation = inputData =>
  //   inputData.language.length > 0 &&
  //   inputData.movieName !== '' &&
  //   inputData.movieNamete !== '' &&
  //   inputData.poster.length > 0 &&
  //   inputData.Bio.length > 3 &&
  //   inputData.biote !== '' &&
  //   inputData.genRe.length >= 1 &&
  //   inputData.Moviecast.length >= 1 &&
  //   inputData.Moviedirector.length >= 1 &&
  //   inputData.MovieProducer.length >= 1

  // const checkReviewValidationEn = inputData =>
  //   (inputData.movieReviewArticleTitleEn && inputData.MovieYouSayReviewUrl) ||
  //   (!inputData.movieReviewArticleTitleEn && !inputData.MovieYouSayReviewUrl)
  // const checkReviewValidationTe = inputData =>
  //   (inputData.movieReviewArticleTitleTe && inputData.MovieYouSayReviewUrlTe) ||
  //   (!inputData.movieReviewArticleTitleTe && !inputData.MovieYouSayReviewUrlTe)

  // const releaseDateValidation = (status, releaseDate) => {
  //   if (status.includes('MovieReleaseDateRevealed')) {
  //     return releaseDate !== ''
  //   }

  //   return true
  // }

  // // Function to check the existence of both OTT and URL fields
  // const checkOttAndUrl = (inputData, data) => {
  //   if (
  //     inputData.OTTStatus ===
  //       'OTTProviderDateAndLinkAvailable' ||
  //     inputData.OTTStatus ===
  //       'OTTProviderRevealedAndLinkAvailableAndDateNotKnown'
  //   ) {
  //     data.every((element, index) => {
  //       const ottLabelPresent = inputData.ott[index].label
  //       const urlNotEmpty = element.link.length > 0

  //       // Both OTT label and URL are either both present or both absent
  //       return ottLabelPresent && urlNotEmpty
  //     })
  //   } else {
  //     return true
  //   }
  // }

  // Function to disable the update button if required conditions are not met
  // const updateButtonDisable = () => {
  //   // Check if input data.Movielinks is not empty
  //   let ottDates = []

  //   if (inputData.Movielinks.length !== 0) {
  //     inputData.Movielinks.forEach(e => {
  //       if (e.ottDate) {
  //         ottDates.push(parseInt(new Date(e.ottDate).getTime(), 10))
  //       }
  //     })

  //     ottDates = ottDates.filter(e => e)
  //   }

  //   const checkOttFieldsExists =
  //     inputData.Movielinks &&
  //     inputData.Movielinks.length > 0 &&
  //     inputData.Movielinks.some(
  //       (e, index) => inputData.ott[index] && inputData.ott[index].label !== '',
  //     )

  //   const checkOttFieldsDateExists = checkOttFieldsDateExistsorNot(
  //     checkOttFieldsExists,
  //     ottDates,
  //   )

  //   const checkIfBothOttAndUrl = checkOttAndUrl(inputData.Movielinks)
  //   const releaseDateCheck = releaseDateValidation(
  //     inputData.movieStatus,
  //     inputData.releaseDate,
  //   )
  //   const validation = checkValidation(inputData)
  //   const reviewValidation = checkReviewValidationEn(inputData)
  //   const reviewValidationTe = checkReviewValidationTe(inputData)

  //   return !(
  //     Object.values(BooleanValueChangeDone).some(e => e === true) &&
  //     validation &&
  //     releaseDateCheck &&
  //     inputData.wikilink.length >= 4 &&
  //     inputData.restrit !== '' &&
  //     episodesandRating &&
  //     (inputData.OTTStatus ===
  //       'OTTProviderRevealedAndDateAnnounced' ||
  //     inputData.OTTStatus ===
  //       'OTTProviderAndDateKnownAndLinkNotAvailable' ||
  //     inputData.OTTStatus ===
  //       'OTTProviderDateAndLinkAvailable'
  //       ? checkOttFieldsDateExists
  //       : true) &&
  //     (inputData.OTTStatus ===
  //       'OTTProviderDateAndLinkAvailable' ||
  //     inputData.OTTStatus ===
  //       'OTTProviderRevealedAndLinkAvailableAndDateNotKnown'
  //       ? checkIfBothOttAndUrl
  //       : true) &&
  //     ((inputData.OTTStatus ===
  //       'OTTProviderDateAndLinkAvailable' ||
  //     inputData.OTTStatus ===
  //       'OTTProviderRevealedAndLinkAvailableAndDateNotKnown' ||
  //       inputData.OTTStatus ===
  //       'OTTProviderAndDateKnownAndLinkNotAvailable' ||
  //       inputData.OTTStatus ===
  //       'OTTProviderRevealedAndDateAnnounced'
  //       )
  //       ? checkOttFieldsExists
  //       : true) &&
  //     reviewValidation &&
  //     reviewValidationTe
  //   )
  // }
  const updateButtonDisable = () => {
    // Extract ottDates from Movielinks
    const ottDates = inputData.Movielinks.filter(e => e.ottDate).map(e =>
      new Date(e.ottDate).getTime(),
    )

    // Check if ottLabel and ottLink are present based on ottStatus
    const hasOTTFields =
      inputData.Movielinks &&
      inputData.Movielinks.length > 0 &&
      inputData.Movielinks.some(
        (e, index) => inputData.ott[index] && inputData.ott[index].label !== '',
      )

    // const hasOTTLinks =
    //   inputData.Movielinks &&
    //   inputData.Movielinks.length > 0 &&
    //   inputData.Movielinks.some(e => e && e.link !== '')

    // Check if ottFieldsDate exists or not
    const hasOTTFieldsDate = checkOttFieldsDateExistsorNot(hasOTTFields, ottDates)

    // Check if both ott and url are available
    const hasOTTAndUrl = checkOttAndUrl(inputData, inputData.Movielinks)

    // Validate release date
    const releaseDateValid = releaseDateValidation(
      inputData.movieStatus,
      inputData.releaseDate,
      inputData,
    )

    // Validate other input data
    const isValid =
      checkValidation(inputData) &&
      releaseDateValid &&
      inputData.wikilink.length >= 4 &&
      inputData.restrit !== '' &&
      episodesandRating
    const reviewValidationEn = checkReviewValidationEn(inputData.yousayArticleReviews)
    const reviewValidationTe = checkReviewValidationTe(inputData.yousayArticleReviews)
    const articleReviewRatingCheck = checkArticleRating(inputData.yousayArticleReviews)
    const aricleValidation = ArticleValidation(
      reviewValidationEn,
      reviewValidationTe,
      articleReviewRatingCheck,
    )
    // Check if any conditions fail for disabling the button
    return !(
      (
        Object.values(BooleanValueChangeDone).some(e => e === true) &&
        isValid &&
        episodesandRating &&
        (inputData.OTTStatus === 'OTTProviderRevealedAndDateAnnounced' ||
        inputData.OTTStatus === 'OTTProviderAndDateKnownAndLinkNotAvailable' ||
        inputData.OTTStatus === 'OTTProviderDateAndLinkAvailable'
          ? hasOTTFieldsDate
          : true) &&
        (inputData.OTTStatus === 'OTTProviderDateAndLinkAvailable' ||
        inputData.OTTStatus === 'OTTProviderRevealedAndLinkAvailableAndDateNotKnown'
          ? hasOTTAndUrl
          : true) &&
        (checkOTTStatus(inputData) ? hasOTTFields : true) &&
        aricleValidation
      )
      // ottFieldsCheck &&
    )
  }

  // Function to update input data
  const sendInputData = data => {
    setInputData(data)
  }

  // Function to handle pk value input
  const pkValueInput = value => {
    setPkValue(value)
  }

  // Function to trigger rendering of edit data
  const editRender = () => {
    setIsLoading(true)
    getMovieData(pkvalue)
    setBooleanValueforDisplayingUi(true)
  }

  // Function to submit values to service on click to update
  const submitEditMovie = async () => {
    setIsLoading(true)

    const update = await SubmitEditMovie(movieData, inputData, BooleanValueChangeDone)

    if (update === 'A001') {
      if (EDitApproveOptionBoolean && movieData.status === 'draft') {
        setIsLoading(false)
        setLoadPopup(true)
      } else {
        setIsLoading(false)
        history.go(`/editmovie?${pkvalue}`)
      }
    } else {
      setIsLoading(false)
    }
  }

  // useEffect to fetch movie data when the component mounts or when certain dependencies change
  useEffect(() => {
    getMovieData()
  }, [props.dataFromWiki])
  // useEffect to handle visibility change and fetch data if the tab becomes visible
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (!document.hidden && !movieData) {
        // Tab is visible, and movieData is not available, fetch data
        getMovieData()
      }
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)

    // Fetch data when the component is mounted if movieData is not available
    if (!movieData) {
      getMovieData()
    }

    // Cleanup the event listener when the component unmounts
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [movieData])

  return (
    <Uicomponentmovie
      inputData={inputData}
      handlecontentTypeChange={handleContentTypeChange}
      editData={editData}
      modeUrl={modeUrl}
      pkvalue={pkvalue}
      BooleanValueforDisplayiingUi={BooleanValueforDisplayingUi}
      pkvalueinput={pkValueInput}
      editRender={editRender}
      isLoading={isLoading}
      active={active}
      handleActiveChange={handleActiveChange}
      movieData={movieData}
      moviePersons={moviePersons}
      BooleanValueChangeDone={BooleanValueChangeDone}
      sendBooleanValueChangeDone={sendBooleanValueChangeDone}
      updateInputData={updateInputData}
      sendinputdata={sendInputData}
      updateButtondisable={updateButtonDisable}
      submitEditMovie={submitEditMovie}
      setIsLoading={setIsLoading}
      EDitApproveOptionBoolean={EDitApproveOptionBoolean}
      loadPopup={loadPopup}
      setHorizontalImage={setHorizontalImage}
      setLoadPopup={setLoadPopup}
      horizonataImage={horizonataImage}
      setmoviedata={setMovieData}
      editOttAndNewsPermission={editOttAndNewsPermission}
      DeleteOttAndNewsPermission={DeleteOttAndNewsPermission}
      ApproveOttAndNewsPermission={ApproveOttAndNewsPermission}
    />
  )
}

export default EditMovie
